var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBogoStickyNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.77,
  d: "M6.875 1.375v1.833a.917.917 0 0 0 .917.917h1.833m-2.292-2.75H2.292a.917.917 0 0 0-.917.917v6.416a.917.917 0 0 0 .917.917h6.416a.917.917 0 0 0 .917-.917V3.667z"
})));
export default SvgBogoStickyNote;